import { useState, useCallback } from 'react';
import TicketAPI from '../api/CaseTicketsAPI';
import { useEffect } from 'react';

export const useTicketByCaseId = (caseId) => {
    const [ticket, setTicket] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchTicket = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await TicketAPI.getTickets({ caseId });
            if (!data.success) {
                throw new Error('Error fetching ticket');
            }
            data.payload && setTicket(data.payload[0] || null);
        } catch (e) {
            console.error(e);
            setTicket(null); 
        } finally {
            setLoading(false);
        }
    }, [caseId]);

    useEffect(() => {
        fetchTicket();
    }, [fetchTicket]);

    return {
        ticket,
        loading,
        fetchTicket
    }
}
